<template>
  <div class="portfolio-section">
    <v-container>
      <div class="section-header" data-aos="fade-up">
        <div class="badge-wrapper">
          <v-chip color="primary" outlined class="section-badge">
            <v-icon left small>mdi-star-circle</v-icon>
            {{ badge }}
          </v-chip>
        </div>
        <h2 class="title-style section-title">{{ title }}</h2>
        <p v-if="subtitle" class="section-subtitle">{{ subtitle }}</p>
      </div>

      <template v-if="apps && apps.length > 0">
        <v-slide-group
          class="portfolio-slider"
          show-arrows
          center-active
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <v-slide-item
            v-for="(app, index) in apps"
            :key="app.id || index"
            v-slot="{ toggle }"
          >
            <app-showcase-card
              :app="app"
              @click.native="openProject(app)"
            />
          </v-slide-item>
        </v-slide-group>
      </template>

      <div v-else class="empty-state" data-aos="fade-up">
        <v-icon size="80" color="primary lighten-2">mdi-folder-open-outline</v-icon>
        <p class="empty-message">{{ emptyMessage }}</p>
      </div>
    </v-container>
  </div>
</template>

<script>
import AppShowcaseCard from './AppShowcaseCard.vue'

export default {
  name: 'ShowcaseApps',
  components: { AppShowcaseCard },
  props: {
    title: { type: String, default: 'Our Featured Projects' },
    subtitle: { type: String, default: '' },
    badge: { type: String, default: 'Portfolio' },
    apps: { type: Array, default: () => [] },
    emptyMessage: { type: String, default: 'No projects available yet.' }
  },
  methods: {
    openProject(app) {
      if (!app || !app.id) return

      const rawPath = `/portfolio/${app.id}`
      const localizedPath = this.localePath ? this.localePath(rawPath) : rawPath

      this.$router.push({
        path: localizedPath,
        query: { from: this.$route.fullPath }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "./showcase-apps-style.scss";
</style>
